/**
 * @desc undefined
 */
import { ScanResult, ScanForm } from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type ScanCallbackParameter = ScanForm

const method = 'GET'
const url = '/auth/wechat/scan_callback'

export const scanCallbackApi = (
  params?: ScanCallbackParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<ScanResult>({
    method,
    url,
    params,
    ...config
  })
}

scanCallbackApi.method = method
scanCallbackApi.url = url
